/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react';
import {XMarkIcon} from "@heroicons/react/24/solid";
import clsx from "clsx";

interface TableFilterRemoveButtonProps {
    inputValue?: unknown;
    onClick: () => void;
    className?: string
    classNameIcon?: string
}

const TableFilterRemoveButton = (props: TableFilterRemoveButtonProps) => {
    return (
        <button className={clsx("TableFilterRemoveButton absolute -right-6", props.className, !props.inputValue && "border-r-0")} type={"button"} onClick={props.onClick}>
            <XMarkIcon className={clsx("w-5 h-5 ml-1", props.classNameIcon && props.classNameIcon, (!props.inputValue) ? "text-gray-500 opacity-0" : "text-red-500")} />
        </button>
    );
};

export default TableFilterRemoveButton;